import styled from 'styled-components';
import { colors } from 'styles/colors';

export const Container = styled.div<{ $height: string }>`
  width: 100%;
  height: ${({ $height }) => $height};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.text['sub-500']};
  font-size: 13px;
`;
